import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { onboardFormActions } from "../../../store/onboardFormState"


export const UndertakingConsentModal = ({ id, show, close, content }) => {

    const dispatch = useDispatch()

    const [agreeButtonDisable, setAgreeButtonDisable] = useState(true)

    const checkUndertaking = () => {
        dispatch(onboardFormActions.checkUndertaking({ id: id, checked: true }))
        close()
    }


    useEffect(() => {
        if (show) {
            document.getElementsByTagName("body")?.[0]?.classList.add("modal-open")
            setTimeout(() => {
                document.getElementById("Open-NDA-Sign")?.classList.add("show")
            }, 100)
        }
        else {
            document.getElementsByTagName("body")?.[0]?.classList.remove("modal-open")
        }
        setAgreeButtonDisable(true)

    }, [show])

    return (
        show ? <div>
            <div
                className="modal fade"
                id="Open-NDA-Sign"
                style={{ display: "block" }}
                aria-modal="true"
                role="dialog"
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content rounded-15">
                        <div className="modal-body px-70 py-40">
                            <p className="font-20 font-md-30 font-weight-800">
                            Terms & Conditions
                            <div style={{fontSize:"10px"}}> (Read all terms and conditions below before moving to next step)</div>
                           
                            </p>
                            <p className="scroll-height-300" onScroll={(e) => {
                                let element = e.target
                                if (Math.abs(element.scrollHeight - element.scrollTop - element.clientHeight) <= 1 && agreeButtonDisable) {
                                    setAgreeButtonDisable(false)
                                }

                            }}>  {content}</p>
                            <div className="row mt-5">
                                <div className="mt-2" style={{ display: "flex" }}>
                                    <button type="button" className="btn btn-default" disabled={agreeButtonDisable} onClick={checkUndertaking}>
                                        Agree
                                    </button>
                                    <button type="button" className="btn btn-light ml-50" onClick={close}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`modal-backdrop fade ${show && "show"}`} />
        </div>
            : <div></div>
    )
}